<template>
  <el-dialog
    :title="$t('eventList.AppPro')"
    :visible.sync="dialogVisible"
    width="40%"
    class="approvalProcessDialog"
  >
    <el-scrollbar class="approvalProcessScrollbar">
      <commonProcess :all-process-data="allProcessData" />
    </el-scrollbar>
  </el-dialog>
</template>

<script>
import commonProcess from './commonProcess';
import { annualApplicationApi } from '../service';
export default {
  data () {
    return {
      dialogVisible: false,
      allProcessData: []
    };
  },
  components: {
    commonProcess
  },
  methods: {
    init (parameter) {
      const { dialogVisible, id } = parameter;
      this.dialogVisible = dialogVisible;
      this.allProcessData = [];
      annualApplicationApi.annualPlanApprovalRecords({ id }).then(res => {
        if (res.status === '200') {
          const result = JSON.parse(JSON.stringify(res.data));
          if (result && result.length > 0) {
            let data = result[0].processHistoryVO;
            result.forEach(ite => {
              if (ite.processHistoryVO.mactFlowLogList && ite.processHistoryVO.mactFlowLogList.length > 0) {
                const mactFlowLogList = ite.processHistoryVO.mactFlowLogList.map(item => {
                  return {
                    title: item.node,
                    details: item.reason,
                    type: item.approveType,
                    name: item.assigneeName,
                    time: item.createTime,
                    active: ite.processHistoryVO.processState === 'completed'
                  };
                });
                if (ite.processHistoryVO.processState === 'completed') {
                  mactFlowLogList.push({
                    name: this.$t('general.End'),
                    active: true
                  });
                }
                this.allProcessData.push(mactFlowLogList);
              }
            });
          }
        }
      });
      this.$nextTick(() => {
            let ele = document.querySelector('.approvalProcessScrollbar>.el-scrollbar__wrap');
            ele.scrollTo(0, ele.scrollHeight);
          });
    }
  }
};
</script>

<style lang="scss" scoped>
.approvalProcessDialog{
  ::v-deep.el-dialog{
    .approvalProcessScrollbar{
      >.el-scrollbar__wrap {
        overflow-x: hidden;
        max-height: 500px;
      }
    }
    .processTitle{
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 16px;
      &~.processTitle{
        margin-top: 10px;
      }
    }
  }
}
</style>
